import React from 'react';
import { Outlet } from 'react-router-dom';
import { Layout } from 'antd';
import { useSelector } from 'react-redux';
import SideBar from 'layouts/SideBar';
import NavHeader from 'layouts/NavHeader';
import './DashboardLayout.scss';

const { Content } = Layout;

function DashBoardLayout() {
  const theme = useSelector((state) => state.user.theme);
  // const [showBanner, setShowBanner] = useState(true);
  // const location = useLocation();

  // const planModal = useSelector((state) => state.user.planModal);
  // const dispatch = useDispatch();
  // const togglePlanModal = () => {
  //   dispatch(updatePlanModal(!planModal));
  // };
  // const isTrialActivate = useSelector((state) => state.user.plan.trial_activate);
  // const endDate = useSelector((state) => state.user.plan.end_date);
  // const currentDate = dayjs();
  // const dueDate = dayjs(endDate);
  // const days = dueDate.diff(currentDate, 'day');
  // const dayLeft = days < 0 ? days : days + 1;
  // // const formattedDate = formatDateWithOrdinal(dueDate);
  // const isCurrentDateGreaterThanDueDate = currentDate.isAfter(dueDate);

  // let message = '';

  // if (dayLeft < 0) {
  //   // Trial has ended, extend if it's within the grace period
  //   message = (
  //     <>
  //       Your free trial of <span style={{ color: '#85E6C4' }}>Premium Plan</span> has been extended
  //       to 7 more days
  //     </>
  //   );
  // } else if (!isCurrentDateGreaterThanDueDate && dayLeft <= 7 && dayLeft > 0) {
  //   // Within the trial period
  //   message = (
  //     <span>
  //       Your free trial of <span style={{ color: '#85E6C4' }}>Premium Plan</span> ends in {dayLeft}{' '}
  //       {dayLeft === 1 ? 'day' : 'days'}
  //     </span>
  //   );
  // } else if (isCurrentDateGreaterThanDueDate) {
  //   // After the trial period
  //   const dayAgo = dayLeft * -1 + 1;
  //   message =
  //     dayAgo === 0 ? (
  //       <span>
  //         Your free trial of <span style={{ color: '#85E6C4' }}>Premium Plan</span> will end today
  //       </span>
  //     ) : (
  //       <span>
  //         Your free trial of <span style={{ color: '#85E6C4' }}>Premium Plan</span>{' '}
  //         {Math.abs(dayLeft)} {dayAgo === 1 ? 'day' : 'days'} ago
  //       </span>
  //     );
  // }

  return (
    <Layout
      style={{
        height: '100vh',
        overflow: 'hidden',
        backgroundColor: '#FAFAFF'
      }}
    >
      <SideBar
        style={{
          position: 'fixed',
          top: 0,
          bottom: 0,
          left: 0,
          width: '200px',
          zIndex: 1000,
          background: '#FAFAFF'
        }}
      />
      <Layout
        style={{
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          background: '#FAFAFF'
        }}
      >
        <NavHeader
          style={{
            position: 'sticky',
            top: 0,
            zIndex: 1001,
            background: '#fff'
          }}
        />
        {/* {!isTrialActivate && showBanner && location.pathname !== '/settings' && (
          <div
            style={{
              margin: '20px',
              fontSize: '20px',
              textAlign: 'center',
              background: 'linear-gradient(rgb(109, 68, 229), 65%, rgb(75 51 144))',
              padding: '16px 0',
              borderRadius: '5px',
              color: '#ffffff',
              position: 'relative'
            }}
          >
            Grow your partnership revenue with{' '}
            <span style={{ color: '#85E6C4' }}>Premium Plan </span> of Easebuzz Partner Programme
            <EbzButton
              size="large"
              onClick={togglePlanModal}
              style={{ color: var(--color-primary), margin: '0 40px' }}
            >
              Start Free Trial
            </EbzButton>
            <CloseCircleOutlined
              style={{
                cursor: 'pointer',
                position: 'absolute',
                top: '50%',
                transform: 'translate(0, -50%)',
                right: '20px'
              }}
              onClick={() => setShowBanner(false)}
            />
          </div>
        )}
        {showBanner && isTrialActivate && location.pathname !== '/settings' && dayLeft <= 7 && (
          <div
            style={{
              margin: '20px',
              fontSize: '20px',
              textAlign: 'center',
              background: 'linear-gradient(rgb(109, 68, 229), 65%, rgb(75 51 144))',
              padding: '16px 0',
              borderRadius: '5px',
              color: '#ffffff',
              position: 'relative'
            }}
          >
            {message}
            <EbzButton
              size="large"
              style={{ color: var(--color-primary), margin: '0 40px' }}
              onClick={() => {
                Alert('Support', 'Please contact support team for this', 'info');
              }}
            >
              Renew Your Plan
            </EbzButton>

            <CloseCircleOutlined
              style={{
                cursor: 'pointer',
                position: 'absolute',
                top: '50%',
                transform: 'translate(0, -50%)',
                right: '20px'
              }}
              onClick={() => setShowBanner(false)}
            />
          </div>
        )} */}
        <Content
          style={{
            position: 'relative',
            zIndex: '2',
            marginBottom: '50px',
            overflowY: 'scroll',
            maxHeight: '100vh'
          }}
        >
          <Outlet />
        </Content>
        {theme.backGroundWaterMark && (
          <img
            src={theme.backGroundWaterMark}
            alt="logo"
            style={{
              position: 'absolute',
              bottom: '10px',
              right: '25px',
              width: 'auto',
              height: '300px',
              zIndex: '1',
              opacity: '0.4'
            }}
          />
        )}
      </Layout>
    </Layout>
  );
}

export default DashBoardLayout;
